<p-autoComplete appendTo="body" minLength="2" inputId="multiple-ac-1" virtualScroll="false" [virtualScrollItemSize]="34"
    [scrollHeight]="'250px'"
    [ngModelOptions]="{ standalone: true }" [(ngModel)]="productSelectedItem" [dropdown]="false" [forceSelection]="true"
    [suggestions]="products" (completeMethod)="filterProducts($event)" field="displayName"
    (onSelect)="onProductSelected($event)" placeholder="Search Product...">
    dataKey="id" >
</p-autoComplete>
